module.exports = __webpack_public_path__ + "static/media/img-a03025e0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gif/h-edge-1.gif
// module id = 5270
// module chunks = 39